"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TouristsPickerDesktop = exports.Style = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CounterPluralize = _interopRequireDefault(require("../CounterPluralize"));
var _KidsList = _interopRequireDefault(require("./components/KidsList"));
var _AddChild = _interopRequireDefault(require("./components/AddChild"));
var _SearchSelect = require("../SearchSelect");
var _pluralizeUtils = require("../../utils/pluralizeUtils");
var _utils = require("./utils");
// Components:

// Interfaces:

// Utils

var TouristsPickerDesktop = exports.TouristsPickerDesktop = function TouristsPickerDesktop(props) {
  var adultsValue = props.adultsValue,
    _props$kidsValue = props.kidsValue,
    kidsValue = _props$kidsValue === void 0 ? [] : _props$kidsValue,
    _props$minValue = props.minValue,
    minValue = _props$minValue === void 0 ? 1 : _props$minValue,
    _props$maxValue = props.maxValue,
    maxValue = _props$maxValue === void 0 ? 4 : _props$maxValue,
    _props$maxChildren = props.maxChildren,
    maxChildren = _props$maxChildren === void 0 ? 3 : _props$maxChildren,
    _props$minChildAge = props.minChildAge,
    minChildAge = _props$minChildAge === void 0 ? 0 : _props$minChildAge,
    _props$maxChildAge = props.maxChildAge,
    maxChildAge = _props$maxChildAge === void 0 ? 17 : _props$maxChildAge,
    _props$onChangeAdults = props.onChangeAdults,
    onChangeAdults = _props$onChangeAdults === void 0 ? function () {
      return undefined;
    } : _props$onChangeAdults,
    _props$onChangeKids = props.onChangeKids,
    onChangeKids = _props$onChangeKids === void 0 ? function () {
      return undefined;
    } : _props$onChangeKids,
    CustomControl = props.CustomControl,
    CustomLabel = props.CustomLabel,
    CustomDropdownIndicator = props.CustomDropdownIndicator,
    _props$isHotelOnly = props.isHotelOnly,
    isHotelOnly = _props$isHotelOnly === void 0 ? false : _props$isHotelOnly,
    _props$isOpenInitial = props.isOpenInitial,
    isOpenInitial = _props$isOpenInitial === void 0 ? false : _props$isOpenInitial;
  var handleChangeKids = function handleChangeKids(val) {
    onChangeKids(val);
  };
  var handleAddChildren = function handleAddChildren(_ref) {
    var target = _ref.target;
    var val = target.value;
    var newKidsValue = kidsValue.concat(parseInt(val, 10));
    handleChangeKids(newKidsValue);
  };
  var handleRemoveChildren = function handleRemoveChildren(_ref2) {
    var currentTarget = _ref2.currentTarget;
    var index = currentTarget.dataset.index;
    var newKidsValue = kidsValue.filter(function (val, idx) {
      return idx !== parseInt(index, 10);
    });
    handleChangeKids(newKidsValue);
  };
  var kidsCount = kidsValue.length;
  var canAddChild = kidsCount < maxChildren;
  var touristsLabel = (0, _utils.getTouristsLabel)({
    adultsValue: adultsValue,
    kidsValue: kidsValue
  });
  var CustomSingleValue = CustomControl ? CustomLabel : function (labelProps) {
    var innerProps = labelProps.innerProps,
      selectProps = labelProps.selectProps;
    var menuIsOpen = selectProps.menuIsOpen;
    return /*#__PURE__*/_react["default"].createElement(StyledLabel, (0, _extends2["default"])({}, innerProps, {
      menuIsOpen: menuIsOpen
    }), touristsLabel);
  };
  var CustomOption = function CustomOption() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledCounterPluralize, {
      value: adultsValue,
      buttonSize: 24,
      fontWeight: 400,
      fontSize: 14,
      text: (0, _pluralizeUtils.pluralizeAdults)(adultsValue),
      onChange: onChangeAdults,
      minValue: minValue,
      maxValue: maxValue
    }), kidsCount > 0 ? /*#__PURE__*/_react["default"].createElement(_KidsList["default"], {
      kidsValue: kidsValue,
      onRemoveChildren: handleRemoveChildren
    }) : null, canAddChild ? /*#__PURE__*/_react["default"].createElement(_AddChild["default"], {
      minChildAge: minChildAge,
      maxChildAge: maxChildAge,
      onAddChild: handleAddChildren
    }) : null);
  };
  var Option = {
    custom: true,
    CustomComponent: CustomOption
  };
  var customStyles = {
    menu: function menu() {
      return {
        width: 230,
        'border-radius': 'var(--border-radius)'
      };
    },
    menuList: function menuList() {
      return {
        overflow: 'visible',
        padding: 0,
        maxHeight: 'unset'
      };
    },
    valueContainer: function valueContainer() {
      return {
        padding: 0
      };
    },
    control: function control() {
      return {
        minHeight: 'unset',
        height: 'unset'
      };
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_SearchSelect.SearchSelect, {
    options: [Option],
    customStyles: customStyles,
    isClearable: false,
    isSearchable: false,
    closeMenuOnSelect: false,
    CustomSingleValue: CustomSingleValue,
    CustomDropdownIndicator: isHotelOnly ? function () {
      return null;
    } : CustomDropdownIndicator,
    captureMenuScroll: false,
    menuShouldBlockScroll: false,
    defaultMenuIsOpen: isOpenInitial
  });
};
var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "TouristsPickerdesktop__StyledLabel",
  componentId: "sc-1issv8j-0"
})(["font-size:18px;line-height:22px;font-weight:500;color:var(--black);"]);
var StyledCounterPluralize = (0, _styledComponents["default"])(_CounterPluralize["default"]).withConfig({
  displayName: "TouristsPickerdesktop__StyledCounterPluralize",
  componentId: "sc-1issv8j-1"
})(["height:50px;padding:0 10px;"]);
var Style = exports.Style = {
  StyledLabel: StyledLabel
};